import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=1f72d0e2&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=1f72d0e2&prod&lang=scss&scoped=true"
import style1 from "./Checkbox.vue?vue&type=style&index=1&id=1f72d0e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f72d0e2",
  null
  
)

export default component.exports